/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Permit } from "./Permit";
import type { PermitSession } from "./PermitSession";
export type PayPermitOutcome = {
  details: {
    email_sent: boolean;
    permit: Permit;
    sessions: Array<PermitSession>;
  };
  kind: PayPermitOutcome.kind;
} | {
  details: {
    access_code_id: string;
  };
  kind: PayPermitOutcome.kind;
} | {
  kind: PayPermitOutcome.kind;
};
export namespace PayPermitOutcome {
  export enum kind {
    SUCCEEDED = "succeeded",
  }
}
